import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesService } from '../../services.service';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [ServicesService]
})
export class LoginComponent implements OnInit {

    hidePass: boolean = true;
    disableBtnEntrar: boolean = false;
    msgLogin: string = '';

    constructor(private router: Router, private _services: ServicesService) {}

    onSubmit(formData: NgForm) {
        // rotas
        const rota = this.router;

        this.disableBtnEntrar = true;
        this.msgLogin = '';
        if (formData.valid) {
            this._services.getToken(formData.value).then(
                gtoken => {
                    if (gtoken.sucesso) {
                        // grava os dados da sessao no browser
                        this._services.setLocalStorage('plataformaWeb', gtoken);
                        rota.navigate(['dashboard']);
                    } else {
                        this.disableBtnEntrar = false;
                        this.msgLogin = gtoken.message;
                        console.warn('Lat. Bela Vista: Plataforma Web: Erro de login - ' + gtoken.message);
                    }
                }
            );
        } else {
            // formulário não preenchido corretamente
            this.msgLogin = 'Usuário ou senha inválida.';
            this.disableBtnEntrar = false;
        }
    }

    ngOnInit() {
    }

}
